import React from "react";
import "./home.scss";
import Desktop from "../../../src/Media/Home_Desktop.webp";
import Mobile from "../../../src/Media/Home_Mobile.webp";
import Banner from "../../Section/Home/Banner/banner";
import About from "../../Section/Home/secondhero/SecondHero";
import Produklist from "../../Section/Home/Produk/produk";
import Promo from "../../Section/Home/Promo/promo";
import Launch from "../../Section/Home/comingsoon/soon";
import Newlaunch from "../../Section/Home/soon/comingsoon";
import Produk from "../../Section/Home/BrizaLakes/FnB1";
import Kavling from "../../Section/Kavling BSD/kavling";
import Lokasi from "../../Section/Home/Lokasi/lokasi";
import Scrolltohashelement from "../Home/ScrollToHashElement";
import tombol from "../../Media/tombol.webp";
const home = () => {
  const fungsiganteng = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6282172727291&text=Halo%20Swandy,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Komersial%20BSD%20Gading%20Serpong%20https://komersialbsdgadingserpong.com//&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };
  const poin = [
    "Siap Huni",
    "Free DP",
    "Voucher Cashback Up To 270",
    "Free AC",
    "Free IPKL",
    "Strategic Location",
    "10k Daily Vehicle Traffic",
    "78k Surrounding Market",
    "Easy Access",
    "High Potential Captive Market",
    "Surrounded by Many Residential",
  ];
  return (
    <div className="home">
      <Scrolltohashelement />

      <Banner Desktop={Desktop} Mobile={Mobile} />
      <About />
      <Promo poin={poin} />
      <Newlaunch />
      <Launch />
      <Produk />
      <Kavling />
      <Produklist />
      <Lokasi />
      <img
        onClick={fungsiganteng}
        src={tombol}
        className="tombolwa"
        alt="Hubungi Sekarang!"
      />
    </div>
  );
};

export default home;
